import { render, staticRenderFns } from "./LayoutMenuCollapse.vue?vue&type=template&id=837ff89e"
import script from "./LayoutMenuCollapse.vue?vue&type=script&lang=js"
export * from "./LayoutMenuCollapse.vue?vue&type=script&lang=js"
import style0 from "./LayoutMenuCollapse.vue?vue&type=style&index=0&id=837ff89e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports